import axios from 'axios'

export const handleSave = (data, fields, collectionName) => {
  const payload = []
  const objField = {}
  let objIndex = 0
  let nullFields = 0
  for (const obj of data) {
    if (objIndex > 0) {
      for (let x = 1; x <= fields.length; x++) {
        objField[fields[x - 1]] = obj[x].value
      }
      const ol = Object.keys(objField)
      for (const field of ol) {
        if (!objField[field] || objField[field].trim() === '') {
          nullFields++
        }
      }
      if (nullFields !== fields.length) {
        payload.push({ ...objField })
      }
      nullFields = 0
    }
    objIndex++
  }

  axios({
    method: 'POST',
    url: `${process.env.REACT_APP_API_KEY}/spreadsheet/${collectionName}`,
    headers: {
      'Api-Key':
        '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130'
    },
    data: { data: payload }
  })
    .then(response => {
      const { data } = response.data
      alert(`${data.insertedCount} records successfully updated`)
    })
    .catch(err => {
        
    })
}
